import React from 'react';
import { AppBar, Button, Container, Tab, Tabs, Toolbar, Typography } from '@material-ui/core';
import { TabPanel } from '@material-ui/lab';
import MyCases from './MyCases';
import SharedCases from './SharedCases';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  tabsStyle: {
    borderBottom: '1px solid #e8e8e8',
  },
});

const NavigationTabs = (props: any) => {
  const classes = useStyles();

  const { match, history } = props;
  const { params } = match;
  const { page } = params;

  const tabNames = [
    'my-cases',
    'shared-cases',
    'patients',
    'collaborators'
  ];

  const [selectedTab, setSelectedTab] = React.useState(tabNames.indexOf(page));

  const handleChange = (event: any, newValue: any) => {
    history.push(`/${tabNames[newValue]}`);
    console.log('history:');
    console.log(history);
    setSelectedTab(newValue);
  };

  return (
    <Container maxWidth='md'>
      <Tabs value={selectedTab} onChange={handleChange} className={classes.tabsStyle}>
        <Tab label='My cases' />
        <Tab label='Shared cases' />
        <Tab label='Collaborators' />
        <Tab label='Settings' />
      </Tabs>
      {selectedTab === 0 && <MyCases />}
      {selectedTab === 1 && <SharedCases />}
    </Container>
  );
}

export default NavigationTabs;
